import { Document } from 'mobx-document'
import { BeWizrActivity } from '~/models'

export default class BeWizrActivityDocument extends Document<BeWizrActivity> {
  protected async performFetch() {
    // Not supported
    return null
  }
}